import en from './en'
import de from './de'
import es from './es'
import fr from './fr'
import fi from './fi'

export default { en, de, es, 'en-uk': en, fr, fi }
